import { setDocTitle } from "../../../functions/HelperFuncs";

export default {
  created() {
    setDocTitle("Spaces", this);
  },
};
